import script from "./GuideMsgUnit.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideMsgUnit.vue?vue&type=script&setup=true&lang=js"

import "./GuideMsgUnit.vue?vue&type=style&index=0&id=23f1f52c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f1f52c"]])

export default __exports__